import React from 'react';

export const AuthContext = React.createContext({
  isSignedIn: false,
  currentUser: null,
  isLoadingUser: true,
  handleAuthStateChange: () => {},
});
